import { css } from 'styled-components';
import { colors } from 'constants/colors';
import { toHex } from 'helpers/color';
import { TColor } from 'types/common/color';

export type ITypographyColor =
  | 'red'
  | 'green'
  | 'gray'
  | 'lightGray'
  | 'blue'
  | 'grayBlue'
  | 'gold'
  | 'transparent'
  | 'default'
  | 'inherit'
  | 'disabled';

export type ITypographyDecoration =
  | 'blink'
  | 'line-through'
  | 'overline'
  | 'underline'
  | false;

export interface ITypography {
  color?: TColor;
  $decoration?: ITypographyDecoration;
  $bold?: boolean;
  $uppercase?: boolean;
  $nowrap?: boolean;
  $fontWeight?: number;
}

export const typographyProps = css`
  font-style: normal;

  color: ${({ color }: ITypography) => (color ? toHex(color) : colors.grayBlue9)};

  font-weight: ${({ $bold, $fontWeight }: ITypography) =>
    $bold ? '700' : $fontWeight || '500'};

  white-space: ${({ $nowrap }: ITypography) => ($nowrap ? 'nowrap' : 'normal')};

  ${({ $uppercase }: ITypography) =>
    $uppercase &&
    css`
      text-transform: uppercase;
    `};

  ${({ $decoration }: ITypography) =>
    $decoration &&
    css`
      text-decoration: ${$decoration};
    `};
`;
